import { createPortal } from "react-dom";

export default function AppNotification({ notification, aboveNavigation = false }) {
  if (!notification) {
    return null;
  }

  return createPortal(
    <div className="app-modal-backdrop app-modal-backdrop--notification" role="presentation"><section className={`app-modal app-modal--notification ${notification.status ? "app-modal--success" : "app-modal--warning"}`} role="status" aria-live="polite"><p>{notification.message}</p></section></div>,
    document.body,
  );
}
